<template>
  <el-form-item label="标题">
    <el-input v-model="activeData.config.label" placeholder="请输入标题" />
  </el-form-item>
</template>

<script>
export default {
  name: 'ConfigItemSubForm',
  props: ['activeData']
}
</script>

<style scoped></style>
